(function() {
  document.addEventListener('click', function(e) {
    // 找到被点击的 buy-now 按钮（或其子元素的父按钮）
    var btn = e.target.closest('[data-buy-now-btn]');
    if (!btn) return;

    var form = btn.closest('form[action="/cart/add"]') 
               || document.querySelector('form[action="/cart/add"]');
    var variantId = form 
      ? form.querySelector('[name="id"]').value 
      : btn.dataset.variantId;
    var quantity = (form && form.querySelector('[name="quantity"]'))
      ? form.querySelector('[name="quantity"]').value 
      : 1;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
    })
    .then(function(res) {
      if (res.ok) window.location.href = '/checkout';
    })
    .finally(function() {
      btn.disabled = false;
    });
  });
})();

//产品详情页Description模块显示隐藏功能
(function () {
  'use strict';

  function initDescExpand() {
    const wrappers = document.querySelectorAll('[data-desc-expand]');

    wrappers.forEach(function (wrapper) {
      const inner = wrapper.querySelector('[data-desc-inner]');
      const content = wrapper.querySelector('[data-desc-content]');
      const btn = wrapper.querySelector('[data-desc-btn]');

      if (!inner || !content || !btn) return;

      const moreText = btn.dataset.moreText || 'Show more';
      const lessText = btn.dataset.lessText || 'Show less';

      // 计算内容实际行数
      function getLineCount() {
        const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
        const height = content.scrollHeight;
        return Math.round(height / lineHeight);
      }

      function collapse() {
        inner.classList.add('is-collapsed');
        btn.textContent = moreText;
      }

      function expand() {
        inner.classList.remove('is-collapsed');
        btn.textContent = lessText;
      }

      function setup() {
        // 仅在 lg 断点以上（≥1024px）生效
        if (window.innerWidth < 1024) {
          inner.classList.remove('is-collapsed');
          btn.style.display = 'none';
          return;
        }

        const lineCount = getLineCount();

        if (lineCount > 10) {
          collapse();
          btn.style.display = 'inline-block';
        } else {
          inner.classList.remove('is-collapsed');
          btn.style.display = 'none';
        }
      }

      btn.addEventListener('click', function () {
        if (inner.classList.contains('is-collapsed')) {
          expand();
          btn.classList.add('is-expanded');
        } else {
          collapse();
          btn.classList.remove('is-expanded');
        }
      });



      // 初始化
      setup();

      // 窗口 resize 时重新判断
      window.addEventListener('resize', debounce(setup, 200));
    });
  }

  function debounce(fn, delay) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescExpand);
  } else {
    initDescExpand();
  }
})();